"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueStore = void 0;
var ValueStore = (function () {
    function ValueStore(state) {
        if (state === void 0) { state = {}; }
        this.store = Object.freeze(state);
    }
    ValueStore.prototype.isEmpty = function () {
        return Object.keys(this.store).length === 0;
    };
    ValueStore.prototype.has = function (key) {
        return this.store[key] ? true : false;
    };
    ValueStore.prototype.get = function (key) {
        if (typeof key === "string") {
            return this.store[key];
        }
        else {
            return this.store;
        }
    };
    return ValueStore;
}());
exports.ValueStore = ValueStore;
